export default __webpack_public_path__ + "static/media/BrunoSylin.f54b94b9.png";